import {Component} from '@angular/core';
import {AlertController, NavController, LoadingController} from 'ionic-angular';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {MembershipService} from './membership.service';
import {AuthService} from './../../../../services/auth';
import {SessionService} from './../../../../services/session';
import {LocationsService} from './../../../../services/locations';
import {BackendModule} from './../../../../modules/backend.module';
import {UpdateMembershipPage} from './update-membership/update-membership';
import {NewComplementPage} from './new-complement/new-complement';


@Component({
  selector: 'page-complements',
  templateUrl: 'complements.html'
})
export class ComplementsPage {
  newMembershipPage = NewComplementPage;
  updateMembershipPage = UpdateMembershipPage;
  constructor(private iab: InAppBrowser,
              public backendModule: BackendModule,
              public alertCtrl: AlertController,
              public sessionService: SessionService,
              public membershipService: MembershipService,
              public navCtrl: NavController,
              public authService: AuthService,
              public loadingCtrl: LoadingController,
              public locationsService: LocationsService) {
  }

  goTo(page) {
    this.navCtrl.push(page)
  }

  select(planIndex: number) {
    this.membershipService.selectBeautyPlan(planIndex);
    this.navCtrl.push(this.newMembershipPage)
  }

  showCancelMembershipAlert() {
    const returnButton = {
      text: 'No, regresar',
      role: 'cancel',
    };

    const cancelButton = {
      text: 'Sí, cancelar membresía',
      cssClass: 'red-cancel-button',
      handler: () => {
        this.cancelMembership();
      }
    };

    const alert = this.alertCtrl.create({
      title: 'Cancelar membresía',
      message: '¿Estás seguro que deseas cancelar tu membresía?',
      buttons: [returnButton, cancelButton],
    });

    alert.present();
  }

  cancelMembership() {
    const loading = this.loadingCtrl.create();
    loading.present();

    this.membershipService.cancelBeautyMembership().subscribe(
      () => {
        this.authService.getUserInfo(this.sessionService.user.id);
        const alert = this.alertCtrl.create({
          title: 'Se canceló correctamente tu membresía',
          message: 'Podrás seguir utilizando tu membresía hasta tu fecha de ' +
            this.locationsService.translate('expiry'),
          buttons: [{text: 'OK', role: 'cancel',}],
        });

        loading.dismiss()
          .then(() => alert.present());
      },
      err => {
        this.sessionService.reportError(
          'complementsPage',
          'cancelMembership()',
          err
        );

        const alert = this.alertCtrl.create({
          title: 'Error al cancelar, inténtalo más tarde',
          message: err.error.errors.general[0] || 'Cualquier duda: ' + this.locationsService.translate('infoMail'),
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
            },
          ]
        });

        loading.dismiss()
          .then(() => alert.present());
      }
    )
  }

  openBrowser(url) {
    this.iab.create(url, '_blank');
  }

  ionViewDidLoad() {
    window['page'] = 'ComplementsPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/membership/complements.ts